import { CvSectionConfigClass, CvSectionConfigDTO } from './cv-section-config-dto';

export interface CvResearcherSectionDTO extends CvSectionConfigDTO {
    type: 'researcher';
}

export class CvResearcherSectionClass extends CvSectionConfigClass implements CvResearcherSectionDTO {
    type: 'researcher';

    constructor(section?: CvResearcherSectionClass) {
        super(section);
        Object.assign(this, section);
    }
}
